// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_m8-0";
export var discountCodeInput = "_m8-1";